import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'video-player-dialog',
    templateUrl: './video-player-dialog.component.html',
    styleUrls: ['./video-player-dialog.component.scss'],
    standalone: false
})
export class VideoPlayerDialogComponent implements OnInit {
  @Input() videoPassedIn: any;

  @ViewChild("dialogVideoPlayer", { static: true }) dialogVideoPlayer: ElementRef;

  constructor(public dialogRef: MatDialogRef<VideoPlayerDialogComponent>) { }

  ngOnInit() :void {
  }

  closeDialog() {
    return this.dialogRef.close(null);
  }
}